document.getElementById("client-timezone").value = Intl.DateTimeFormat().resolvedOptions().timeZone

moment.tz.add(
  "Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6"
);

var teachersOnHollidays = [
  { teacher: "EXAMPLE", start: "2023/06/13", end: "2023/06/14" },
  { teacher: "Daniela ", start: "2023/06/13", end: "2023/10/16" },
]

var showAllHours = window.location.search.includes("showAllHours=true");

var weekdayValue = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 7,
};

var weekdayTranslation = JSON.parse(
  document.getElementById("week-of-days-translations").textContent
);
var otherTranslation = JSON.parse(
  document.getElementById("other-schedule").textContent
).other;

var product = JSON.parse(
  document.getElementById("ProductJson-product-template").textContent
);
var stockByVariant = JSON.parse(
  "{" +
    document
      .getElementById("VariantJson-product-template")
      .textContent.slice(0, -1)
      .split("\n")
      .map((a) =>
        a
          .split(":")
          .map((b) => '"' + b + '"')
          .join(":")
      )
      .join(",") +
    "}"
);
var scheduleSelect = document.getElementById("ProductSelect--product-template");
var otherScheduleOption = document.createElement("option");
otherScheduleOption.value = "other";
otherScheduleOption.innerText = otherTranslation;
scheduleSelect.append(otherScheduleOption);

var userDateTime = document.getElementById("user-date-time");
setInterval(function () {
  var now = moment()
    .locale(localStorage.wglang || "es")
    .format("LLL");
  if (userDateTime.innerText !== now) {
    userDateTime.innerText = now;
  }
}, 200);


var languaje
var interval = setInterval(function() {
  if(!localStorage.wglang) {
    return
  }
  if(languaje && languaje === localStorage.wglang) {
    return
  }
  languaje = localStorage.wglang
  main()
}, 100)


function main() {
  Array.from(scheduleSelect.children).slice(1,-1).forEach((child) => scheduleSelect.removeChild(child))
  
  var options = product.variants
    .filter(function (variant) {
      return (
        Boolean(variant.sku) && variant.available && !variant.sku.endsWith("#N")
      );
    })
    .map(function (variant) {
      var value = variant.id;
      var sku = variant.sku;
  
      var data = sku.split("#");
      var teacher = data[0];
      var weekday = data[1];
      var start = data[2];
      var end = data[3];
      var tz = getTimezone(data[5] || data[4]);
  
      var momentsStart = getMoments(weekdayValue[weekday], start, tz);
      var momentsEnd = getMoments(weekdayValue[weekday], end, tz);
  
      return {
        value,
        sku,
        teacher,
        weekday,
        start,
        end,
        momentsStart,
        momentsEnd,
      };
    })
    .filter(function (data) {
      var stock = stockByVariant[data.value];
      if (
        product.title.includes("Principiantes") ||
        product.title.includes("Lectoescritura")
      ) {
        if (stock < 4) {
          return true;
        }
      } else {
        if (stock < 6) {
          return true;
        }
      }
      if (isOnHollidays(data.teacher, data.momentsStart.local)) {
        return false;
      }
      var tomorrow = moment().add(1, "day");
      return data.momentsStart.local.isAfter(tomorrow);
    })
    .map(function (data) {
      var text =
        data.momentsStart.local.locale(localStorage.wglang).format("dddd") +
        " " +
        data.momentsStart.local.format("HH:mm") +
        " - " +
        data.momentsEnd.local.format("HH:mm");
      var sorter = ((data.momentsEnd.local.weekday() + 6) % 7) + data.momentsEnd.local.format("HH:mm")
      return createOption(
        text,
        data.value,
        data.sku,
        data.momentsStart,
        data.momentsEnd,
        sorter
      );
    })
    .filter((option) => {
      const startTime = /\d\d:\d\d/.exec(option.innerText)[0];
      return showAllHours || (startTime >= "07:00" && startTime <= "21:00");
    })
    .sort((option1, option2) => {
      return option1.attributes["sorter"].localeCompare(option2.attributes["sorter"]);
    })
    .forEach(function (option) {
      otherScheduleOption.insertAdjacentElement("beforebegin", option);
    });
    
  var elementsToSwitch = document.querySelectorAll(".element-to-switch");
  var statusSwitch = "validOptions";
  
  scheduleSelect.addEventListener("change", function (event) {
    var selected = event.target.selectedOptions[0];
    if (selected.value === "other") {
      document.getElementById("class-schedule").value = "";
      statusSwitch === "validOptions" && switchView();
  
      document.getElementById("first-class-container").hidden = true;
      document.getElementById("locale-first-day-input").value = "";
      document.getElementById("first-day-p").innerText = "";
      document.getElementById("first-day-input").value = "";
    } else {
      document.getElementById("class-schedule").value = selected.innerText;
      statusSwitch === "needOtherOptions" && switchView();
  
      document.getElementById("first-class-container").hidden = false;
      document.getElementById("locale-first-day-input").value =
        selected.attributes["data-first-day-local"];
      document.getElementById("first-day-p").innerText =
        selected.attributes["data-first-day-local"];
      document.getElementById("first-day-input").value =
        selected.attributes["data-first-day-london"];
      document.getElementById("first-start-datetime").value =
        selected.attributes["data-first-start-datetime"];
      document.getElementById("first-end-datetime").value =
        selected.attributes["data-first-end-datetime"];
    }
  });
  
  function switchView() {
    statusSwitch =
      statusSwitch === "validOptions" ? "needOtherOptions" : "validOptions";
    elementsToSwitch.forEach(function (element) {
      element.hidden = !element.hidden;
    });
  }
}

function createOption(text, value, dataSku, startMoments, endMoments, sorter) {
  var option = document.createElement("option");
  option.classList.add("capitalize")
  option.value = value;
  option.attributes["data-sku"] = dataSku;
  if (startMoments) {
    option.attributes["data-first-day-london"] =
      startMoments.london.format("D/M/yyyy");
    option.attributes["data-first-day-local"] = startMoments.local
      .locale(localStorage.wglang || "es")
      .format("LL");
    option.attributes["data-first-start-datetime"] = startMoments.local
      .toISOString()
      .replace(/\d\d\.\d\d\d/, "00.000");
    option.attributes["data-first-end-datetime"] = endMoments.local
      .toISOString()
      .replace(/\d\d\.\d\d\d/, "00.000");
    option.attributes["sorter"] = sorter;
  }
  option.innerText = text;
  return option;
}

function get24Time(time) {
  var regexResult = /(\d+):(\d+)(\w+)/.exec(time);
  var h = Number(regexResult[1]);
  var m = Number(regexResult[2]);
  var a = regexResult[3];
  var h24 = a === "pm" ? (h === 12 ? h : h + 12) : h === 12 ? 0 : h;
  return [h24, m];
}

function getMoments(weekday, time, tz) {
  var time24 = get24Time(time);
  var h = time24[0];
  var m = time24[1];

  var londonMoment = moment
    .tz(tz)
    .weekday(weekday)
    .hour(h)
    .minute(m);
  var londonNow = moment.tz(tz);
  if (londonNow.diff(londonMoment) > 0) {
    londonMoment.add(7, "days");
  } else if (londonNow.diff(londonMoment, "days") <= -7) {
    londonMoment.subtract(7, "days");
  }
  return {
    london: londonMoment,
    local: moment(londonMoment.toISOString()),
  };
}

function isOnHollidays(teacher, lessonStart) {
  return teachersOnHollidays.some((holliday) => {
    if(holliday.teacher !== teacher) {
      return false
    }
    
    var startHolliday = moment(holliday.start + "Z", "YYYY-MM-DDZ")
    var endHolliday = moment(holliday.end + "Z", "YYYY-MM-DDZ")
    return lessonStart.isBetween(startHolliday, endHolliday)
  })
}

function getTimezone(tz) {
  switch(tz) {
    case "NYC":
      return 'America/New_York'
    case "TYO":
      return 'Asia/Tokyo'
    case "SYD":
      return 'Australia/Sydney'
    default:
      return 'Europe/London'
  }
}